// eslint-disable-next-line import/prefer-default-export
export const EATING_OUT_CHALLENGE_PROTOTYPE_V1 = 'eatingOutChallengePrototypeV1';
